import { RelativeDateFilterUnit } from "types/dates/date-types";

const RelativeDateMaxValues: Record<RelativeDateFilterUnit, number> = {
  days: 10000,
  weeks: 1000,
  months: 300,
  quarters: 100,
  years: 20,
} as const;

export default RelativeDateMaxValues;
